export const setConfigSMTP = (state, reqResponse) => {
    state.configSMTP = reqResponse.data;
    state.configSMTP.host = `${state.configSMTP.host}:${state.configSMTP.port}`;
    state.loadingNotifications = false;
};

export const setConfigSMS = (state, reqResponse) => {
    state.configSMS = reqResponse.data;
    state.loadingNotifications = false;
};

export const setEmail = (state, reqResponse) => {
    state.email = reqResponse.data;
};

export const setSms = (state, reqResponse) => {
    state.sms = reqResponse.data;
};
